export const EXPECTED_INVOICE_GENERATION_DATE="expectedInvoiceGenerationDate"
export const EXPECTED_INVOICE_SUBMISSION_DATE="expectedInvoiceSubmissionDate"
export const EXPECTED_INVOICE_CLEARANCE_DATE="expectedInvoiceClearanceDate"
export const INVOICE_GENERATION_DATE="invoiceGenerationDate"
export const INVOICE_CODE="invoiceCode"
export const INVOICE_FILE="invoiceFile"
export const INVOICE_OWNER="invoiceOwner"
export const INVOICE_OWNER_ROLE="invoiceOwnerRole"
export const BANK_ACCOUNT_DETAILS="bankAccountDetail"
export const INVOICE_SUBMISSION_DATE="invoiceSubmissionDate"
export const INVOICE_REMARKS="invoiceRemark"


